import React, { useEffect, useState } from 'react'
import { makeStyles } from '@material-ui/styles'
import { Header, Page, CustomTable, ModalConfirmacao} from 'components'
import { useUsuarioService } from 'hooks/useUsuarioService'
import { useSessionService } from 'hooks/useSessionService'
import { CircularProgress, Typography, Tooltip } from '@material-ui/core'
import { useAuth } from 'hooks/useAuth'
import constants from 'utils/constants'
import useRouter from 'utils/useRouter'
import EditIcon from '@material-ui/icons/Edit'
import AutorenewIcon from '@material-ui/icons/Autorenew'
import { Formulario } from './components/Formulario'
import { ModalConfirmarAcao } from 'views/ExamesSolicitados/ExameSolicitado/components/MenuAcoes/components/ModalConfirmarAcao'
import { capitalizeWords } from 'utils/helpers'
const useStyles = makeStyles((theme) => ({
  root: {
    padding: theme.spacing(3),
    fontSize: '14px',
  },
  carregando: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    margin: 20,
  },
  nomeSetor: {
    marginInline: '4px',
  },
}))

export const Usuarios = (props) => {
  const { route } = props
  const { permissoesUsuario, verificarPermissao } = useAuth()
  const router = useRouter()
  const classes = useStyles()
  const usuarioService = useUsuarioService()
  const sessionService = useSessionService()
  const [usuarios, setUsuarios] = useState([])
  const [usuarioSelecionado, setUsuarioSelecionado] = useState(null)
  const [openModalRedefinirSenha, setOpenModalRedefinirSenha] = useState(false)
  const [openModalAlertaRedefinirSenha, setOpenModalAlertaRedefinirSenha] = useState(false)
  const [processandoUsuarios, setProcessandoUsuarios] = useState(false)
  const [processandoAcao, setProcessandoAcao] = useState(false)
  const [formRedefinirSenha, setFormRedefinirSenha] = useState({})
  const [formRedefinirSenhaValido, setFormRedefinirSenhaValido] = useState(false)


  const handleClickEditarDetalhes = (rowData) => {
    router.history.push(router.location.pathname + `/editar/${rowData.id}`)
  }

  const handleClickRedefinirSenha = (rowData) => {
    setUsuarioSelecionado(rowData)
    setFormRedefinirSenha({})
    setFormRedefinirSenhaValido(false)
    setOpenModalRedefinirSenha(true)
  }
  const onCloseModalRedefinirSenha = () => {
    setOpenModalRedefinirSenha(false)
    setFormRedefinirSenha({})
    setFormRedefinirSenhaValido(false)
  }

  const handleConfirmarRedefinirSenha = () => {
    if (!formRedefinirSenhaValido) {
      return
    }
    setOpenModalAlertaRedefinirSenha(true)
    setOpenModalRedefinirSenha(false)
  }

  const handleConfirmarAcaoRedefinirSenha = async () => {
    setOpenModalAlertaRedefinirSenha(false)
    setProcessandoAcao(true)
    await sessionService.redefinirSenhaAdmin(
      { ...formRedefinirSenha, cpf: usuarioSelecionado.cpf },
      setProcessandoAcao
    )
    setFormRedefinirSenha({})
    setFormRedefinirSenhaValido(false)
    setProcessandoAcao(false)
  }

  const rotaAdmin = router.location.pathname.startsWith('/usuarios')

  useEffect(() => {
    const fetchUsuarios = async () => {
      setProcessandoUsuarios(true)
      if (rotaAdmin) {
        const usuarios = await usuarioService.listarTodosOsUsuarios(setProcessandoUsuarios)
        setUsuarios(usuarios)
      } else {
        const usuarios = await usuarioService.listarUsuariosExternos(setProcessandoUsuarios)
        setUsuarios(usuarios)
      }
      setProcessandoUsuarios(false)
    }

    fetchUsuarios()
  }, [rotaAdmin])

  useEffect(() => {
    if (permissoesUsuario?.length) {
      if ((rotaAdmin && !verificarPermissao([constants.PERMISSOES.ADMINISTRAR_SISTEMA]))
      || (!rotaAdmin && !verificarPermissao([constants.PERMISSOES.CADASTRAR_USUARIO]))) {
        router.history.push(`/`)
      }
    }
  }, [permissoesUsuario])

  return (
    <Page className={classes.root} title={`${route.secao} - SIGEP`}>
      {processandoUsuarios || !usuarios ? (
        <div className={classes.carregando}>
          <CircularProgress disableShrink />
        </div>
      ) : (
        <>
          <Header titulo={`${route.secao} cadastrados`} overline={route.secao} textoBotao="CADASTRAR NOVO" linkBotao={`${route.path}/cadastrar`} />
          <CustomTable
            title=""
            columns={[
              {
                title: 'Nome',
                field: 'nome',
                width: 'fit-content',
              },
              {
                title: 'Cargo',
                field: 'cargo.nome',
                render: (rowData) => (rowData.cargo?.nome?.toUpperCase() || ''),
                sorting: false,
              },
              {
                title: 'Setor',
                render: (rowData) => {
                  if (rowData.setores && rowData.setores[0]) {
                    const setores = rowData.setores
                    let outrosSetores = []
                    if (setores.length > 4) {
                      outrosSetores = setores.slice(3)
                    }
                    const setoresExibidos = setores.slice(0, 3)
                    return outrosSetores.length > 0 ? (
                      <>
                        {setoresExibidos.map(s => (
                          <Tooltip title={<Typography>{s.nome}</Typography>} key={s.id}>
                            <Typography className={classes.nomeSetor} component='span'>{s.sigla}</Typography>
                          </Tooltip>
                        ))}
                        <Tooltip title={<Typography>{outrosSetores.map(s => s.nome).join(', ')}</Typography>}>
                          <Typography className={classes.nomeSetor} component='span'>+{outrosSetores.length}</Typography>
                        </Tooltip>
                      </>
                    ) : (
                      setoresExibidos.map(s => (
                        <Tooltip title={<Typography>{s.nome}</Typography>} key={s.id}>
                          <Typography className={classes.nomeSetor} component='span'>{s.sigla}</Typography>
                        </Tooltip>
                      ))
                    )

                  } else {
                    return 'Não cadastrado'
                  }
                },
                sorting: false,
                customFilterAndSearch: (term, rowData) => {
                  if (rowData.setores && rowData.setores[0]) {
                    return rowData.setores.some(setor => setor.nome.toLowerCase().includes(term.toLowerCase()))
                  }
                  return false
                },
              },
              {
                title: 'Matrícula',
                field: 'matricula',
                sorting: false,
                customFilterAndSearch: (term, rowData) => {
                  return rowData.matricula?.replace(/-|\./g, '').includes(term.replace(/-|\./g, ''))
                }
              },
              { 
                title: 'CPF', 
                field: 'cpf',
                sorting: false,
                customFilterAndSearch: (term, rowData) => {
                  return rowData.cpf?.replace(/-|\./g, '').includes(term.replace(/-|\./g, ''))
                }
              },
            ]}
            data={usuarios}
            actions={[
              {
                icon: EditIcon,
                tooltip: 'Editar detalhes',
                onClick: (event, rowData) => handleClickEditarDetalhes(rowData),
              },
              {
                icon: AutorenewIcon,
                tooltip: 'Redefinir senha',
                onClick: (event, rowData) => handleClickRedefinirSenha(rowData),
              },

            ]}
          />
        </>
      )}
      {usuarioSelecionado && (
      <>
      <ModalConfirmacao
        aberto={openModalRedefinirSenha}
        onClose={onCloseModalRedefinirSenha}
        onConfirm={handleConfirmarRedefinirSenha}
        disabled={!formRedefinirSenhaValido}
        titulo={"Redefinição de senha"}
        confirmarLabel="Redefinir"
        confirmarColor="error"
      >
        <Formulario
          usuario={usuarioSelecionado}
          form={formRedefinirSenha}
          setForm={setFormRedefinirSenha}
          onValidityChange={setFormRedefinirSenhaValido}
        />
      </ModalConfirmacao>

      <ModalConfirmarAcao
        mensagem={`Deseja realmente redefinir a senha do usuário ${capitalizeWords(usuarioSelecionado?.nome)}?`}
        aberto={openModalAlertaRedefinirSenha}
        onClose={() => {setOpenModalAlertaRedefinirSenha(false)
          setOpenModalRedefinirSenha(true)
        }}
        onConfirm={handleConfirmarAcaoRedefinirSenha}
        processando={processandoAcao}
      />
      </>)}
    </Page>
  )
}
